var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isOnline)?_c('span',{staticClass:"status-bubble status-bubble--online bg-success"},[_vm._v(_vm._s(_vm.onlineText))]):_c('span',{staticClass:"status-bubble status-bubble--offline"},[_vm._v(_vm._s(_vm.offlineText))])])}
var staticRenderFns = []

export { render, staticRenderFns }